import * as R from 'ramda';

const domain = R.prop('savedSearches');

export const getSavedSearches = R.pipe(
  domain,
  R.prop('searches')
);
